export default "__VITE_ASSET__c237c74b__"